import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { isFalsyExceptZero } from '@common/utils/ensure-utils';

export function fieldMatchValidator(control: AbstractControl) {
  const { password, passwordConfirmation } = control.value;

  if (!passwordConfirmation || !password) {
    return null;
  }

  if (passwordConfirmation === password) {
    return null;
  }

  return { fieldMatch: { message: 'Wachtwoorden komen niet overeen' } };
}

export const isValidUrl = (f: UntypedFormControl) => {
  if (isFalsyExceptZero(f.value)) {
    return true;
  }
  return new RegExp(
    '(?:^|\\s)((https?:\\/\\/)?(?:localhost|[\\w-]+(?:\\.[\\w-]+)+)(:\\d+)?(\\/\\S*)?)'
  ).test(f.value);
};

export const isValidEmail = (f: UntypedFormControl) =>
  new RegExp(
    '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'
  ).test(f.value);

export const isHttps = (f: UntypedFormControl) => {
  if (isFalsyExceptZero(f.value)) {
    return true;
  }
  if (typeof f.value !== 'string') {
    return false;
  }
  // Het protocol zelf, niet 'https' ergens in de tekst (zoals in javascript:alert('https'))
  try {
    return new URL(f.value).protocol === 'https:';
  } catch {
    return false;
  }
};

export const isRoundedNumber = (f: UntypedFormControl) => new RegExp('^[1-9]\\d*$').test(f?.value?.toString());
